import { useLanguageStore, type LanguageState } from './store'
import { useShallow } from 'zustand/react/shallow'

export { useLanguageStore }
export type { LanguageState } from './store'

export function useLanguage(): LanguageState
export function useLanguage<T>(selector: (state: LanguageState) => T): T
export function useLanguage<T>(selector?: (state: LanguageState) => T) {
  const shallowSelector = useShallow(selector ?? ((s: LanguageState) => s as unknown as T))
  return useLanguageStore(shallowSelector)
}
